import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { UserService, AuthenticationService } from '../_services';
import { faKey, faHome, faPaperPlane } from '@fortawesome/free-solid-svg-icons';
import { ToastrService } from 'ngx-toastr';
import { MustMatch } from '../_helpers/must-match.validators';

@Component({
    selector: 'app-change-password',
    templateUrl: './change-password.component.html',
    styleUrls: ['./change-password.component.css'],
    standalone: false
})
export class ChangePasswordComponent implements OnInit {

  changePasswordForm! : FormGroup;
  loading = false;
  submitted = false;
  error = '';
  resetToken: string | null = null;
  isAuthenticatedChange = false;

  faKey = faKey;
  faHome = faHome;
  faPaperPlane = faPaperPlane;

  passwordPattern = "^[a-zA-Z0-9]{5,30}$";

  constructor(private formBuilder: FormBuilder,
    private toastr: ToastrService,
    private userService: UserService,
    private authenticationService: AuthenticationService,
    private router: Router,
    private route: ActivatedRoute) { }

  ngOnInit(): void {
    if (!this.authenticationService.currentUserValue?.access_token) {
      this.router.navigate(['/login']);
      return;
    }

    this.resetToken = this.route.snapshot.paramMap.get('token');
    this.isAuthenticatedChange = !!this.authenticationService.currentUserValue?.access_token && !this.resetToken;

    this.changePasswordForm = this.formBuilder.group({
      currentPassword: [''],
      password: ['', [Validators.required, Validators.pattern(this.passwordPattern)]],
      confirmPassword: ['', [Validators.required, Validators.pattern(this.passwordPattern)]]
    }, {
      validators: [MustMatch('password', 'confirmPassword')]
    });

    if (this.isAuthenticatedChange) {
      this.f['currentPassword'].setValidators([Validators.required, Validators.pattern(this.passwordPattern)]);
      this.f['currentPassword'].updateValueAndValidity();
    }
  }

  cancel() {
    this.router.navigate([this.isAuthenticatedChange ? '/home' : '/login']);
  }

  get f() { return this.changePasswordForm.controls; }

  onSubmit() {
    this.submitted = true;
    this.loading = true;

    // stop here if form is invalid
    if (this.changePasswordForm.invalid) {

        this.loading = false;
        return;
    }

    var data = this.changePasswordForm.value;
    var request: any = { password: data.password };

    if (this.resetToken) {
      request.token = this.resetToken;
    } else {
      request.current_password = data.currentPassword;
      request.old_password = data.currentPassword;
    }

    this.userService.changePassword(request).subscribe(
      {
        next: (response) => {
          this.toastr.success(response.message, 'Success');
          this.loading = false;

          if (this.isAuthenticatedChange) {
            this.router.navigate(['/home']);
          } else {
            this.router.navigate(['/login']);
          }
        },
        error: (error) => {
          this.toastr.error(error, 'Error' );
          this.loading = false;
        }
      }
    );


  }


}
